<template>
<div class="benutzerverwaltung container">
  <div class="row mt-5">
    <h1>Benutzerverwaltung</h1>
  </div>
  <div class="row mt-5">
    <div class="col-12 d-flex">
      <h2 class="mr-5 table__btn" :class="{ 'active-btn': currentType == 1 }" v-on:click="currentType = 1;">Wohnungssuchende</h2>
      <h2 class="table__btn " :class="{ 'active-btn': currentType == 2 }" v-on:click="currentType = 2;">Vermieter</h2>
    </div>
    <div class="col-12 mt-5">
      <mdb-input v-model="searchname" :placeholder="'Tabelle durchsuchen'"></mdb-input>
      <div class="result-mieter" v-if="loaded && currentType == 1">
        <table
            id="dtMaterialDesignExample"
            class="table table-striped"
            cellspacing="0"
            width="100%"
        >
          <thead>
          <tr>
            <th class="th-sm" @click="sort('vorname')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'vorname' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'vorname' && currentSortDir == 'desc'"/>
              Vorname
            </th>
            <th class="th-sm" @click="sort('nachname')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'nachname' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'nachname' && currentSortDir == 'desc'"/>
              Nachname
            </th>
            <th class="th-sm" @click="sort('email')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'email' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'email' && currentSortDir == 'desc'"/>
              Email</th>
            <th class="th-sm">Details</th>
          </tr>
          </thead>
          <tbody>

          <tr class="entry--item my-5" v-for="item in resultMieter">

            <td>{{item.vorname}}</td>
            <td>{{item.nachname}}</td>
            <td>{{item.email}}</td>

            <td>
              <mdb-btn color="info" v-on:click="detailsMieter(item.email)">Details</mdb-btn>
            </td>
          </tr>


          </tbody>
        </table>
        <div class="pagination d-flex ">
          <div class="pagination__btn prev"  v-on:click="paginationPrevMieter">Zurück</div>
          <span>Seite {{currentPageMieter}} von {{maxPagesMieter}} ({{results.mieter.length}} Benutzer)</span>
          <div class="pagination__btn next" v-on:click="paginationNextMieter">Nächste</div>
        </div>
      </div>
      <div class="result-mieter" v-if="loaded && currentType == 2">
        <table
            id="dtMaterialDesignExample"
            class="table table-striped"
            cellspacing="0"
            width="100%"
        >
          <thead>
          <tr>
            <th class="th-sm" @click="sort('vorname')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'vorname' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'vorname' && currentSortDir == 'desc'"/>
              Vorname
            </th>
            <th class="th-sm" @click="sort('nachname')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'nachname' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'nachname' && currentSortDir == 'desc'"/>
              Nachname
            </th>
            <th class="th-sm" @click="sort('email')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'email' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'email' && currentSortDir == 'desc'"/>
              Email</th>
            <th class="th-sm">Details</th>
          </tr>
          </thead>
          <tbody>

          <tr class="entry--item my-5" v-for="item in resultVermieter">

            <td>{{item.vorname}}</td>
            <td>{{item.nachname}}</td>
            <td>{{item.email}}</td>
            <td>
              <mdb-btn color="info" v-on:click="detailsVermieter(item.email)">Details</mdb-btn>
            </td>
          </tr>


          </tbody>
        </table>
        <div class="pagination d-flex ">
          <div class="pagination__btn prev"  v-on:click="paginationPrevVermieter">Zurück</div>
          <span>Seite {{currentPageVermieter}} von {{maxPagesVermieter}} ({{results.vermieter.length}} Benutzer)</span>
          <div class="pagination__btn next" v-on:click="paginationNextVermieter">Nächste</div>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import UserService from "@/services/UserService";
import Angebot from "@/components/angebot/vermieter/AngebotVermieter";
import AngebotService from "@/services/AngebotService";
export default {
  name: "Benutzerverwaltung",
  components: {
    Angebot,
  },
  data(){
    return{
      username: "",
      usernameTyping: true,
      results: {
        mieter: [],
        vermieter: [],
      },
      resultType: Number,
      confirm: false,
      Angebote: [],
      userType: 0,
      searchname: "",

      searchedMieter: [],
      searchedVermieter: [],
      currentType: 1,
      currentPageMieter: 1,
      currentPageVermieter: 1,
      itemsPerPage: 50,
      loaded: false,

      currentSort:'vorname',
      currentSortDir:'asc',
    }
  },
  methods:{
    sort:function(s) {
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
    },
    searchUser(){
      this.lastlogin = '';
      UserService.searchVermieter(this.username).then(response =>{
        if(response.data.length > 0){
          this.results = response.data;
          this.resultType = 1;

          AngebotService.getAngeboteSelf(this.results[0].account)
              .then(response => {
                this.Angebote = response.data;
              })
              .catch(error => {
                console.log("There was an error:", error.response);
              });
        } else {
          this.results = {};
        }
      })

      UserService.searchMieter(this.username).then(response =>{
        if(response.data.length > 0){
          this.results = response.data;
          this.resultType = 2;
        }
      })
    },
    changeUserType(type){
      if(this.userType == type ){
        this.userType = 0;
      } else {
        this.userType = type;
      }
    },
    usernameTypingChange(){
      this.usernameTyping = false;
    },
    confirmDelete(){
      this.confirm = true;
    },
    confirmRemove(state){
      if(state){
        this.confirm = false;
        this.deleteUser();
      } else {
        this.confirm = false;
      }
    },
    deleteUser(){
      console.log("Delete User: ", this.userType, this.results)
      if(this.resultType == 1){
        UserService.deleteUserVermieter(this.results[0].account, this.results[0].persistence_object_identifier).then(response => {
          this.$notify.success({
            position: 'top right',
            message: 'Benutzer wurde gelöscht',
            timeout: 3000
          });
          UserService.searchVermieter(this.username).then(response =>{
          })
        })
      } else if(this.resultType == 2){
        UserService.deleteUserMieter(this.results[0].account).then(response => {
          this.$notify.success({
            position: 'top right',
            message: 'Benutzer wurde gelöscht',
            timeout: 3000
          });
          UserService.searchMieter(this.username).then(response =>{
          })
        })
      }

    },
    refreshAngebote(){
      AngebotService.getAngeboteSelf(this.User.account)
          .then(response => {
            this.Angebote = response.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response);
          });
    },

    detailsVermieter(email){
      UserService.searchVermieter(email).then(response =>{
        this.$router.push({ name: 'benutzerverwaltung-single', params: { user: response.data[0], type: 2 } })
      })
    },
    paginationPrevVermieter(){
      if(this.currentPageVermieter > 1){
        this.currentPageVermieter--;
      }
    },
    paginationNextVermieter(){

      if(this.currentPageVermieter +1 <= this.maxPagesVermieter){
        this.currentPageVermieter++;
      }
    },


    detailsMieter(email){
      UserService.searchMieter(email).then(response =>{
        this.$router.push({ name: 'benutzerverwaltung-single', params: { user: response.data[0], type: 1 } })
      })
    },
    paginationPrevMieter(){
      if(this.currentPageMieter > 1){
        this.currentPageMieter--;
      }
    },
    paginationNextMieter(){
      if(this.currentPageMieter +1 <= this.maxPagesMieter){
        this.currentPageMieter++;
      }
    }
  },
  computed: {
    maxPagesMieter(){
      if(this.searchname == '') {
        return Math.floor(this.results.mieter.length / this.itemsPerPage);
      } else {
        return Math.floor(this.searchedMieter.length / this.itemsPerPage);
      }
    },
    resultMieter() {
      let data = this.results.mieter;
      if(this.searchname == ''){
        data.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        })
        return data.slice((this.currentPageMieter - 1) * this.itemsPerPage, this.currentPageMieter * this.itemsPerPage)
      } else {
        this.searchedMieter = data.filter(item => {
          let email = item.email.toLowerCase().indexOf(this.searchname.toLowerCase()) > -1;
          let firstname = item.vorname.toLowerCase().indexOf(this.searchname.toLowerCase()) > -1;
          let lastname = item.nachname.toLowerCase().indexOf(this.searchname.toLowerCase()) > -1;

          return (email || firstname || lastname)
        })
        this.searchedVermieter.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        })
        return this.searchedMieter.slice((this.currentPageMieter - 1) * this.itemsPerPage, this.currentPageMieter * this.itemsPerPage)
      }

    },
    maxPagesVermieter(){
      if(this.searchname == '') {
        return Math.floor(this.results.vermieter.length / this.itemsPerPage);
      } else {
        return Math.floor(this.searchedVermieter.length / this.itemsPerPage);
      }
    },
    resultVermieter() {
      let data = this.results.vermieter;
      if(this.searchname == ''){
        data.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        })
        return data.slice((this.currentPageVermieter - 1) * this.itemsPerPage, this.currentPageVermieter * this.itemsPerPage)
      } else {
        this.searchedVermieter = data.filter(item => {
          let email = item.email.toLowerCase().indexOf(this.searchname.toLowerCase()) > -1;
          let firstname = item.vorname.toLowerCase().indexOf(this.searchname.toLowerCase()) > -1;
          let lastname = item.nachname.toLowerCase().indexOf(this.searchname.toLowerCase()) > -1;

          return (email || firstname || lastname)
        })
        this.searchedVermieter.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        })
        return this.searchedVermieter.slice((this.currentPageVermieter - 1) * this.itemsPerPage, this.currentPageVermieter * this.itemsPerPage)
      }

    }
  },
  mounted() {
    UserService.getAllUsers().then(response => {
      let data = response.data;
      this.results.mieter = data[0];
      this.results.vermieter = data[1];
      this.loaded = true;
    });
  }
}
</script>

<style scoped>
.entry--item td{
  vertical-align: middle;
}
.pagination{
  display: flex;
  justify-content:  space-between;
}
.pagination__btn{
  cursor: pointer;
  font-weight: bold;
}
.table__btn{
 cursor: pointer;
}
.active-btn{
  color: #c1002a;
  font-weight: bold;
}
</style>